import { GraphicalOutputPlaceholder } from '@datacamp/campus-integration';
import { Reconnector } from '@datacamp/le-shared-components';
import * as React from 'react';
import LicenseAgreement from '../components/LicenseAgreement';
import { useLicenseAgreement } from '../lib/hooks/useLicenseAgreement';
import { jsx as ___EmotionJSX } from "@emotion/react";
export const LicenseAgreementManager = _ref => {
  let {
    children,
    environment,
    exercise
  } = _ref;
  const {
    agreed,
    error,
    licenseText,
    onAgree,
    pending,
    retry
  } = useLicenseAgreement({
    environment,
    exercise
  });
  if (error != null) {
    return ___EmotionJSX(Reconnector, {
      restartSession: retry
    });
  }
  if (pending) {
    return ___EmotionJSX(GraphicalOutputPlaceholder, null);
  }
  if (!agreed) {
    return ___EmotionJSX(LicenseAgreement, {
      licenseText: licenseText,
      onAgree: onAgree
    });
  }
  return ___EmotionJSX(React.Fragment, null, children);
};